import React from 'react';
import * as Opt from '../editor/Helpers';
import ColorSelector from '../editor/fields/ColorSelector';
import { LoginContext } from "../login/context/LoginContext";

class PostsVertical extends React.Component {
  static contextType = LoginContext;

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      totalPages: 20,
      posts:[]
    };
    this.handlePageChange = this.handlePageChange.bind(this); // Binding the method
  }

  componentDidMount() {
    this.fetchTotalPages();
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.category != this.props.category || prevProps.pageSize != this.props.pageSize){
      this.fetchTotalPages();
    }
  }

  // fetch request here & page count
  fetchTotalPages = async () => {
    const resp = await fetch(`/cms-api/posts/?pagenr=${this.state.currentPage}&category=${this.props.category.value}&pagesize=${this.props.pageSize}`)
    const json = await resp.json()

    if(resp.ok) {
      this.setState({posts: json.posts, totalPages: json.page_count})
    } else {
      this.setState({posts: [], totalPages: 1})
    }
  };

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber }, () => {
      this.fetchTotalPages();
    });
    //logic here: also browser history
    window.history.pushState({ page: pageNumber }, `Page ${pageNumber}`, `?page=${pageNumber}`);
  };

  handlePermissions = (event, post) => {
    const LoginContext = this.context;

    if(post.category_permissions == 'LOGGED' && !LoginContext.isLogged) {
      event.preventDefault()
      LoginContext.open({next_url: post.url})
      return false;
    }

    return true;
  }

  render() {
    const siblingCount = 2;
    const pageNumbers = [];

    //calculate page number to display
    for(let i = Math.max(1, this.props.currentPage - siblingCount); 1 <= Math.min(this.state.totalPages, this.props.currentPage + siblingCount); i++) {
      pageNumbers.push(i);
    }
    return (
      <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50' : this.props.visibility == "dt" ? 'hidden lg:flex' : this.props.visibility == "mob" ? 'lg:hidden' : 'flex'} p-0 bg-${this.props.backgroundColor}`}>
        <section className={`container`}>
        
          {this.state.posts.map((post) => {
            return <div className='flex w-full rounded-[40px] overflow-hidden mb-[20px] ' style={{height:"205px"}}>
                <a href={post.url} className="flex w-full" onClick={(e) => this.handlePermissions(e, post)}>
                <img src={post.image_url} style={{height:"100%", width:"40%", objectFit:"cover"}} className='hidden md:flex' />
                <div className={`p-[20px] bg-${this.props.cardBackgroundColor}`} style={{background: "#EFEFEF", width:(screen.width >= 768 ? "60%" : "100%")}}>
                  <div className="w-full lg:mb-[30px] flex flex-wrap h-full align-start relative pb-[30px]">
                    <span className={`rounded-full mb-[10px] block fs-8 max-h-[24px] bg-${this.props.categoryBackgroundColor} ${this.props.categoryFontColor}`} style={{padding:"2px 8px", lineHeight:"18px"}}>{post.category_name}</span>
                    <h4 className={`font-medium fs-6 w-full mb-[5px] ${this.props.fontColor}`} style={{fontSize:"20px"}}>{post.title}</h4>
                    <p className={`fs-7 w-full overflow-hidden text-ellipsis ${this.props.fontColor}`} style={{maxHeight:"30px"}}>{post.description}</p>
                    <p className={`fs-7 mb-0 w-full mt-[20px] ${this.props.fontColor}`}>{post.published_date}</p>
                  </div>
                </div>
                </a>
            </div>;
          })}
      <nav aria-label="Page navigation" className="mt-[20px]">
        <ul className="pagination justify-center flex flex-row">
          <li className={`page-item ${this.state.currentPage === 1 ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}>
            <a className={`border border-[##6c757d] py-[5px] px-[15px] rounded-l-[7.5px] hover:bg-[#e9ecef] ${this.state.currentPage === 1 ? '' : 'supp-forest-green cursor-pointer'}`} tabIndex={this.state.currentPage === 1 ? -1 : 0} aria-disabled={this.state.currentPage === 1} onClick={() => this.state.currentPage !== 1 && this.handlePageChange(this.state.currentPage - 1)}>Föregående</a>
          </li>
          {pageNumbers.map((pageNumber) => (
            <li key={pageNumber} className={`page-item ${pageNumber === this.state.currentPage ? 'active' : ''}`}>
              <a className="border border-[##6c757d] py-[5px] px-[15px] hover:bg-[#e9ecef] cursor-pointer" href={`?page=${pageNumber}`} onClick={() => this.handlePageChange(pageNumber)}>{pageNumber}</a>
            </li>
          ))}
          <li className={`page-item ${this.state.currentPage === this.state.totalPages ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}>
            <a className={`border border-[##6c757d] py-[5px] px-[15px] rounded-r-[7.5px] hover:bg-[#e9ecef] ${this.state.currentPage === this.state.totalPages ? '' : 'supp-forest-green cursor-pointer'}`} tabIndex={this.state.currentPage === this.state.totalPages ? -1 : 0} aria-disabled={this.state.currentPage === this.state.totalPages} onClick={() => this.state.currentPage !== this.state.totalPages && this.handlePageChange(this.state.currentPage + 1)}>Nästa</a>
          </li>
        </ul>
      </nav>
      </section>
      </div>
    );
  }
}

PostsVertical.defaultProps = {
  visibility: "",
  category: 1,
  pageSize: 6,
  backgroundColor: 'white-50',
  cardBackgroundColor: 'neutral-cloud-500',
  categoryBackgroundColor: 'supp-forest-green-500',
  categoryFontColor: 'white',
  fontColor: 'neutral-charcoal'
}

PostsVertical.fields = {
  category: {type: "external",
    fetchList: async () => {
      // ... fetch data from a third party API, or other async source
      const resp = await fetch("/admin-api/category/");
      const resp_json = await resp.json();
      return resp_json.map((cat) => {return {"label": cat.name, "value": cat.id}});
    },
  },
  pageSize: {
    type: "number",
  },
  visibility: {
    type: "select",
    options: Opt.visibilityOptions
  },
  backgroundColor: {
    type: "custom",
    render: (props) => <ColorSelector {...props} />
  },
  cardBackgroundColor: {
    type: "custom",
    render: (props) => <ColorSelector {...props} />
  },
  categoryBackgroundColor: {
    type: "custom",
    render: (props) => <ColorSelector {...props} />
  },
  categoryFontColor: {
    type: "select",
    options: Opt.colorVariables
  },
  fontColor: {
    type: "select",
    options: Opt.colorVariables
  },
}

export default PostsVertical;
